import { useMemo, useRef, useState } from "react";
import useNarAgentGridInsuranceOptions from "../../narAgentGrid/hooks/useNarAgentGridInsuranceOptions";
import useNarAgentGridOrgTabs from "../../narAgentGrid/hooks/useNarAgentGridOrgTabs";
import { filterHistoricNarRecommendations } from "../utils/filterHistoricNarRecommendations";
import useHistoricNarRecommendations from "./useHistoricNarRecommendations";

/** Compose lookup, filter, recommendation, table, and modal state for the page. */
const useHistoricNarConfigLayout = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [payer, setPayer] = useState("");
  const [lineOfBusiness, setLineOfBusiness] = useState("");
  const [searchText, setSearchText] = useState("");
  const { insuranceOptions } = useNarAgentGridInsuranceOptions();
  const { tabs: clientOptions } = useNarAgentGridOrgTabs();
  const recommendations = useHistoricNarRecommendations();

  const payerOptions = useMemo(
    () => [{ value: "", label: "All payers" }, ...insuranceOptions],
    [insuranceOptions],
  );
  const visibleRows = useMemo(
    () =>
      filterHistoricNarRecommendations(recommendations.rows, {
        payer,
        lineOfBusiness,
        searchText,
      }),
    [recommendations.rows, payer, lineOfBusiness, searchText],
  );

  return {
    tableRef,
    filters: {
      payer,
      payerOptions,
      onPayerChange: setPayer,
      lineOfBusiness,
      onLineOfBusinessChange: setLineOfBusiness,
      onSearchTextChange: setSearchText,
    },
    results: {
      rows: recommendations.rows,
      visibleRows,
      isLoading: recommendations.isLoading,
      hasFetched: recommendations.hasFetched,
      clientOptions,
      onRefresh: recommendations.refresh,
    },
    modal: {
      clientOptions,
      onIngested: recommendations.refreshSilently,
    },
  };
};

export default useHistoricNarConfigLayout;
